import React, { useEffect, useState, useContext} from "react";
import {getNewsCenter} from '../../../functions/api';
import SearchBox from "./search_box/SearchBox";
import NewsBox from "./news_box/NewsBox";
import { LoadingContext } from "../../../partials/Context";

function NewsCenter() {
    let options = ['responded', 'request'];
    
    const [problem_list, setProblemList] = useState({});
    const [active, setActive] = useState(0);
    const [option, setOption] = useState(options[0]);
    const [displayed_count, setDisplayed] = useState(10);
    const [chosenCategories, setChosen] = useState([]);
    const [unread, setUnread] = useState(false);
    const [searched, setSearched] = useState('');
    const [errors, setErrors] = useState([]);
    const [active_id, setActiveId] = useState('')


    const {loading, setLoading} = useContext(LoadingContext)

    useEffect(() => {
        const id = parseFloat(new URL(window.location.href).searchParams.get('id'))
        if (id) {
            setActive(1)
            setOption(options[1])
            setActiveId(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        setLoading(true)
        getNewsCenter(setProblemList, displayed_count, option, setLoading, chosenCategories, unread, searched, setErrors);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[option, displayed_count, chosenCategories, unread, searched])

    const changeTable = (index) => {
        setActive(index)
        setOption(options[index])
        setDisplayed(10)
    }

    const showMore = () => {
        setDisplayed(prevCount => prevCount + 10)
    }

    const update = () => {
        getNewsCenter(setProblemList, displayed_count, option, setLoading, chosenCategories, unread, searched, setErrors);
    }
    const handleChosen = (event) => {
        let values = []
        event.map((item, i)=> {
            return values.push(item.id)
        })
        setChosen(values)
    }
    const handleUnread = (event) => {
        setUnread(prev => !prev)
    }

    const handleSearch = (event) => {
        setSearched(event.target.value);
    }
    const clearSearch = () => {
        setSearched('');
    }
    return (
        <div className="news_center" id="news_center">
        <div className="background"></div>
            <SearchBox 
                handleChosen={handleChosen}
                handleUnread={handleUnread}
                handleSearch={handleSearch}
                searched={searched}
                clearSearch={clearSearch}
            />
            <NewsBox 
                problem_list={problem_list}
                active={active}
                changeTable={changeTable}
                showMore={showMore}
                update={update}
                loading={loading}
                errors={errors}
                active_id={active_id}
                setActiveId={setActiveId}
                option={option}
            />
        </div>
    )
}

export default NewsCenter;